import type { Etape } from './types.js';

export type EtatEtape = 'fait' | 'en_cours' | 'suivante' | 'a_venir' | 'saute';

export interface EtapeAffichee {
  id: string;
  code: string;
  libelle: string;
  etat: EtatEtape;
  motifSaut: string | null;
  echeance: string | null;
}

export const LIBELLE_ETAT: Readonly<Record<EtatEtape, string>> = {
  fait: 'Terminée',
  en_cours: 'En cours',
  suivante: 'Prochaine',
  a_venir: 'À venir',
  saute: 'Sautée',
};

/** Étapes du dossier dans leur ordre ; la « prochaine » est la première à faire après l’étape en cours. */
export function resumeParcours(etapes: readonly Etape[]): EtapeAffichee[] {
  const triees = [...etapes].sort((a, b) => a.orderIndex - b.orderIndex);
  const dernierEnCours = triees.reduce((rang, e, i) => (e.status === 'en_cours' ? i : rang), -1);
  const suivante = triees.findIndex((e, i) => i > dernierEnCours && e.status === 'a_faire');
  return triees.map((e, i) => ({
    id: e.id,
    code: e.phase,
    libelle: e.label,
    etat: e.status === 'a_faire' ? (i === suivante ? 'suivante' : 'a_venir') : e.status,
    motifSaut: e.status === 'saute' ? e.skippedReason : null,
    echeance: e.dueAt,
  }));
}

/** Échange l’étape avec sa voisine ; aux bornes ou si l’étape est inconnue, l’ordre ne change pas. */
export function deplacer(ids: readonly string[], id: string, sens: -1 | 1): string[] {
  const resultat = [...ids];
  const de = resultat.indexOf(id);
  const vers = de + sens;
  if (de < 0 || vers < 0 || vers >= resultat.length) return resultat;
  [resultat[de], resultat[vers]] = [resultat[vers] as string, resultat[de] as string];
  return resultat;
}

/** Le contrat (StepSkip) exige trois caractères au moins. */
export const motifValide = (motif: string): boolean => motif.trim().length >= 3;
